import Vue from 'vue'
import axios from 'axios'

const vueObj = new Vue()

const state = {
  tags: null,
  systemTags: null,
  multiLevelTags: null,
  coordinationTags: [],
  countTaggedConversation: 0,
  countUntaggedConversation: 0,
  customerChatTopicTags: null,
  canLoadMore: false
}

const actions = {
  fetchCoordinationTags: async ({ commit }) => {
    const { data } = await axios.get('/coordination-tags')
    if (data.coordination_tags && data.coordination_tags.length > 0) {
      commit('SET_COORDINATION_TAGS', data.coordination_tags)
    }
  },
  fetchSystemTags: async ({ commit }, params) => {
    const url = '/tags'
    if (params.customer_type === 'professional_secondary') {
      params.customer_type = 'professional'
    }
    const res = await axios.get(url, { params })
    if (res.status === 200) {
      const systemTags = []
      if (res.data && res.data.length > 0) {
        systemTags.push(...res.data)
      }
      commit('SET_SYSTEM_TAGS', systemTags)
    } else {
      vueObj.$swal({ text: res.data.error })
    }
  },
  fetchTags: async ({ commit }, params) => {
    const url = '/tags'
    if (params.customer_type === 'professional_secondary') {
      params.customer_type = 'professional'
    }
    const res = await axios.get(url, { params })
    if (res.status === 200) {
      const tags = []
      /* let prepareTag = {
        id: 0,
        name: 'ไม่มีแท็ก',
        color: '#000',
        customer_type: params.customer_type
      }
         tags.push(prepareTag)
       */
      if (res.data && res.data.length > 0) {
        tags.push(...res.data)
      }
      commit('SET_TAGS', tags)
    } else {
      vueObj.$swal({ text: res.data.error })
    }
  },
  addTag: async ({ commit }, submitData) => {
    try {
      const url = '/tags'
      await axios.post(url, submitData)
      vueObj.$swal({ text: 'เพิ่มแท็กสำเร็จ', icon: 'success' })
    } catch (e) {
      vueObj.$swal({ text: e.message, icon: 'error' })
    }
  },
  deleteTag: async ({ commit }, id) => {
    const url = `/tags/${id}`
    const res = await axios.delete(url)
    console.log(res)
  }
}

const mutations = {
  SET_TAGS: (state, tags) => {
    state.tags = tags
  },
  SET_COORDINATION_TAGS: (state, tags) => {
    state.coordinationTags = tags
  },
  SET_SYSTEM_TAGS: (state, tags) => {
    state.systemTags = tags
    // console.log('check tags data', tags)
    // Create multi level tags
    const multiLevelTags = []
    let i = 0
    for (const key in tags) {
      if (!tags[key].parent_id) {
        multiLevelTags[i] = tags[key]
        const childTags = []
        for (const childTag of tags) {
          if (childTag.parent_id && childTag.parent_id === multiLevelTags[i].id) {
            childTags.push(childTag)
          }
        }
        if (childTags.length > 0) {
          multiLevelTags[i].child_tags = childTags
        }
        i++
      }
    }
    state.multiLevelTags = multiLevelTags
  },
  SET_COUNT_UNTAGGED_CONVERSATION: (state, count) => {
    state.countUntaggedConversation = count
  },
  SET_COUNT_TAGGED_CONVERSATION: (state, count) => {
    state.countTaggedConversation = count
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
